// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import Vue from "vue";
import api from '@/api';

function findDose(list, dose) {
  if ((dose === undefined) || (dose.ID === undefined)) {
    return {}
  }

  let d = list.find(function(item) {
        return item.ID == dose.ID;
  });
  return d;
}

export default {
  namespaced: true,
  state: {
    doses: [],
    selectedDose: {}
  },
  mutations: {
    setDoses(state, doses) {
      state.doses = doses;
      let d = findDose(state.doses, state.selectedDose);
      state.selectedDose = d;
    },
    setSelectedDose(state, dose) {
      let d = findDose(state.doses, dose);
      state.selectedDose = d;
    },
    updateDose(state, dose) {
      let d = findDose(state.doses, dose)

      let idx = state.doses.indexOf(d);
      if (idx > -1) {
        Vue.set(state.doses, idx, dose);
      } else {
        state.doses.unshift(dose);
      }
    }
  },
  actions: {
    async getDoses({commit}, scheduleid) {
      try {
        let data = await api.getDosesForSchedule(scheduleid);
        commit('setDoses', data || []);
      } catch(err) {
        commit('setDoses', []);
      }
    },
    async createDose({commit}, dose) {
        let d = await api.createDose(dose);
        if (d != null) {
          commit('updateDose', d)
        }
    },
    async updateDose({commit}, dose) {
      let d = await api.updateDose(dose);
        if (d != null) {
          commit('updateDose', d)
        }
    },
    async updateMultiDoses({commit}, doses) {
      let data = await api.updateMultiDoses(doses)
      if (data !== null) {
        data.forEach(function(d) {
          commit('updateDose', d)
        })
      }
    },
    async removeDose({dispatch}, dose) {
      let ok = await api.removeDose(dose);
      if (!ok) {
        throw new Error('error removing dose')
      }
      await dispatch('getDoses', dose.ScheduleID)
    }
  }
}
